module.exports = __webpack_public_path__ + "static/media/mobileDataTile@2x.c2c5eeaf.svg";